<script>
import FormModel from "@/views/Evaluation/EvaluationInterview/Components/FormModel.vue";

export default {
    props: {
        addAction: Boolean,
        updateAction: Boolean,
        viewAction: Boolean,
        deleteAction: Boolean,
    },
    components: {FormModel}
}
</script>

<template>
    <FormModel
        :add-action="addAction"

        :delete-action="deleteAction"
        :view-action="false"
        update-action
        type="EVALUATION_TRAINING_HOT"
    />
</template>